<template>
  <div>
    <Logo />
    <h1>Witaj w kreatorze do personalizacji</h1>
    <p>
      Poniżej możesz zobaczyć wszystkie projekty dostępne do samodzielnej
      personalizacji przy pomocy kreatora.
    </p>
  </div>
</template>

<script>
import Logo from '../Common/Logo.vue'

export default {
  name: 'Headline',
  components: {
    Logo
  }
};
</script>

<style lang="less" scoped>
p {
  max-width: 500px;
  margin: 15px auto 30px;
  color: rgb(146, 146, 146);
}
h1 {
  margin-top: 30px;
}
</style>
